<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { PRIORITY_META } from 'dashboard/helper/conversationLens';

const props = defineProps({
  priority: { type: String, default: null },
  showLabel: { type: Boolean, default: false },
  onlyFlagged: { type: Boolean, default: false },
});

const { t } = useI18n();

const meta = computed(() => PRIORITY_META[props.priority]);

// Most conversations carry no priority at all. The table still needs a cell,
// the list badge does not.
const isVisible = computed(() => {
  if (!meta.value) return !props.onlyFlagged;
  return props.onlyFlagged ? meta.value.flagged : true;
});

const label = computed(() =>
  meta.value ? t(meta.value.labelKey) : t('TICKETS.PRIORITY.NONE')
);
</script>

<template>
  <span
    v-if="isVisible && meta"
    class="inline-flex items-center gap-1 text-xs font-medium"
    :class="meta.toneClass"
    :title="t('TICKETS.PRIORITY.TITLE', { priority: label })"
  >
    <span :class="meta.icon" class="size-3.5 shrink-0" />
    <template v-if="showLabel">{{ label }}</template>
  </span>
  <span v-else-if="isVisible" class="text-xs text-n-slate-10">
    <template v-if="showLabel">{{ label }}</template>
  </span>
</template>
